import * as angular from 'angular';
import * as _ from 'lodash';

import { AcquisitionStrategy, ComponentDefinition, ContextualField, Dictionary, Group, IValueViewModel, ObjectType, PropertyType, TagDefinition } from '../../../models/index';
import { SpotValuesWidgetConfiguration } from '../spotValuesWidget.configuration';
import { spotWidgetsContextualFields } from '../../../common/helpers/contextual';

interface GroupDropdown { guid: string; uniqueName: string }

class SpotValuesWidgetContextualController implements angular.IComponentController {
    errors: ContextualField[];
    properties: ContextualField[];

    readonly cancel: () => void;
    readonly configuration: SpotValuesWidgetConfiguration;
    readonly groups: Group[];
    readonly save: () => void;
    readonly viewModels: Dictionary<IValueViewModel>;

    private _manualSpotGroups: GroupDropdown[];

    static $inject = ['$q'];

    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.initProperties();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['viewModels']?.currentValue) {
            const spotGroups = _.values(this.viewModels)
                .filter(vm => vm.acquisitionStrategy === AcquisitionStrategy.Spot && vm.objectType === ObjectType.Identifier)
                .flatMap(vm => vm.groupList.map(g => ({ guid: g.guid, uniqueName: g.uniqueName } as GroupDropdown)));

            this._manualSpotGroups = _.sortBy(_.uniqBy(spotGroups, g => g.uniqueName), g => g.uniqueName);
            this.initProperties();
        }
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        // TODO restore
        //this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }

    private initProperties() {
        const properties = angular.copy(spotWidgetsContextualFields);
        const groupProperty = _.find(properties, f => f.propertyName === 'groupProperty');
        groupProperty.extraData.groups = this.getSelectableGroups();
        groupProperty.extraData.placement = 'left-top';
        this.properties = properties;
    }

    private getSelectableGroups(): GroupDropdown[] {
        return [{ guid: null, uniqueName: 'Current group' }, ...this._manualSpotGroups ?? []];
    }
}

export const wtSpotValuesWidgetContextual: ComponentDefinition = {
    componentId: 'wtSpotValuesWidgetContextual',
    controller: SpotValuesWidgetContextualController,
    template: require('./spotValuesWidgetContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        cancel: '&?',
        configuration: '<',
        formController: '=',
        groups: '<',
        save: '&?',
        viewModels: '<'
    }
};